import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { getEventById, createEvent, updateEvent } from '../api/eventsApi'
import { appToast } from '../../../../components/AppToast'

export default function useEventsEntry() {
  const { id } = useParams()
  const isEditMode = Boolean(id)
  const navigate = useNavigate()

  const [tDate, setTDate] = useState(() => new Date().toISOString().split('T')[0])
  const [instituteType, setInstituteType] = useState(2) // 1 = Single, 2 = All
  const [instituteId, setInstituteId] = useState('1')
  const [branchType, setBranchType] = useState(2)
  const [branchId, setBranchId] = useState('1')
  const [courseType, setCourseType] = useState(2)
  const [courseId, setCourseId] = useState('1')
  const [batchType, setBatchType] = useState(2)
  const [batchId, setBatchId] = useState('1')
  const [title, setTitle] = useState('')
  const [particulars, setParticulars] = useState('')

  const [isSaving, setIsSaving] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (isEditMode) {
      setLoading(true)
      getEventById(id)
        .then((data) => {
          setTDate(data.tDate || new Date().toISOString().split('T')[0])
          setInstituteType(data.instituteType || 1)
          setInstituteId(data.instituteId ? String(data.instituteId) : '1')
          setBranchType(data.branchType || 1)
          setBranchId(data.branchId ? String(data.branchId) : '1')
          setCourseType(data.courseType || 1)
          setCourseId(data.courseId ? String(data.courseId) : '1')
          setBatchType(data.batchType || 1)
          setBatchId(data.batchId ? String(data.batchId) : '1')
          setTitle(data.title || '')
          setParticulars(data.particulars || '')
        })
        .catch((err) => {
          console.error(err)
          appToast.error('Event record not found.')
          navigate('/cloud/events/list')
        })
        .finally(() => setLoading(false))
    }
  }, [id, isEditMode, navigate])

  const options = {
    institutes: [
      { value: '1', label: 'Tez Educational Trust' },
      { value: '2', label: 'Tolani College Of Commerce' },
      { value: '3', label: 'Tez Educational School' },
    ],
    branches: [
      { value: '1', label: 'Dadar' },
      { value: '2', label: 'Thane' },
      { value: '3', label: 'Andheri' },
      { value: '4', label: 'Borivali' },
    ],
    courses: [
      { value: '1', label: 'CA Foundation' },
      { value: '2', label: 'CS Executive' },
      { value: '3', label: 'JEE Advanced' },
      { value: '4', label: 'NEET UG' },
    ],
    batches: [
      { value: '1', label: 'Batch-A (Morning)' },
      { value: '2', label: 'Batch-CS-01' },
      { value: '3', label: 'Super-30 (Intensive)' },
      { value: '4', label: 'Med-Achievers' },
    ],
  }

  const handleSave = async () => {
    if (!tDate) {
      appToast.error('Please specify a valid event date.')
      return
    }
    if (!title.trim()) {
      appToast.error('Please enter the event name / topic.')
      return
    }

    setIsSaving(true)
    try {
      const selectedInst = options.institutes.find((i) => i.value === instituteId)
      const selectedBranch = options.branches.find((b) => b.value === branchId)
      const selectedCourse = options.courses.find((c) => c.value === courseId)
      const selectedBatch = options.batches.find((b) => b.value === batchId)

      const payload = {
        tDate,
        title: title.trim(),
        particulars: particulars.trim(),
        instituteType,
        instituteId,
        instituteName: selectedInst ? selectedInst.label : '',
        branchType,
        branchId,
        branchName: selectedBranch ? selectedBranch.label : '',
        courseType,
        courseId,
        courseName: selectedCourse ? selectedCourse.label : '',
        batchType,
        batchId,
        batchName: selectedBatch ? selectedBatch.label : '',
      }

      if (isEditMode) {
        await updateEvent(id, payload)
        appToast.success('Entry saved successfully')
      } else {
        await createEvent(payload)
        appToast.success('Entry saved successfully')
      }
      navigate('/cloud/events/list')
    } catch (e) {
      console.error('Failed to save event', e)
      appToast.error('Error saving entry')
    } finally {
      setIsSaving(false)
    }
  }

  return {
    state: {
      isEditMode,
      loading,
      isSaving,
      tDate,
      instituteType,
      instituteId,
      branchType,
      branchId,
      courseType,
      courseId,
      batchType,
      batchId,
      title,
      particulars,
      options,
    },
    actions: {
      setTDate,
      setInstituteType,
      setInstituteId,
      setBranchType,
      setBranchId,
      setCourseType,
      setCourseId,
      setBatchType,
      setBatchId,
      setTitle,
      setParticulars,
      handleSave,
    },
  }
}
